export default __webpack_public_path__ + "static/media/panel1-3.242ccbc6.jpg";